import React, { useCallback, useEffect, useState } from 'react'
import HOC from '../../components/HOC/HOC'
import styles from '../../css/style.module.css'
import { RiDeleteBin6Line } from "react-icons/ri";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { IoSearchSharp } from "react-icons/io5";

import img from '../../assest/img7.png'
import img2 from '../../assest/loading1.gif'

import { Link } from 'react-router-dom';
import { CreateOrderchoose, DeleteSuccessfullyModal, SuccessfullyModal, ViewUserProfile } from '../../components/Modals/Modals';
import endPoints from '../../Repository/apiConfig';
import { deleteApi, getApi } from '../../Repository/Api';
import Pagination from '../../components/Pagination/Pagination';


const columns = [
    'S.no',
    'ID',
    'Name',
    'Email',
    'Number',
    'Wallet',
    'Create Order',
    'View Orders',
    'Action'
];





const AllUser = () => {
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [showUserprfileModal, setShowUserProfileModal] = useState(false)
    const [showModal, setShowModal] = useState(false)

    const [userdata, setUserData] = useState([])
    const [loading, setLoading] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    const [search, setSearch] = useState('')
    const [pagination, setPagination] = useState({
        limit: 10,
        totalPages: 1,
        page: 1,
        hasPrevPage: false,
        hasNextPage: false,
    });

    const fetchData = useCallback(async () => {
        await getApi(endPoints.getalluser(pagination.page, pagination.limit, search), {
            setResponse: setUserData,
            setLoading,
            errorMsg: 'Failed to fetch user!'
        });
    }, [pagination.page, pagination.limit, search]);

    useEffect(() => {
        setPagination((prevPagination) => ({
            ...prevPagination,
            totalPages: userdata?.data?.totalPages,
            hasPrevPage: userdata?.data?.hasPrevPage,
            hasNextPage: userdata?.data?.hasNextPage,
        }));
    }, [userdata]);



    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const handleDelete = async () => {
        if (!selectedUser) return;

        await deleteApi(endPoints.deleteUser(selectedUser), {
            setLoading,
            // successMsg: 'Category deleted successfully!',
            errorMsg: 'Failed to delete staff!'
        });

        fetchData();
        setShowDeleteModal(false);
        setShowSuccessModal(true);
        setTimeout(() => setShowSuccessModal(false), 2000);
    };


    const openDeleteModal = (categoryId) => {
        setSelectedUser(categoryId);
        setShowDeleteModal(true); // Open confirm delete modal
    };



    const openModal = (user) => {
        setSelectedUser(user);
        setShowUserProfileModal(true);
    };

    const handleSearchChange = (e) => {
        setSearch(e.target.value);
        setPagination({ ...pagination, page: 1 }); // Reset to the first page on search
    };

    const openOrderModal = (user) => {
        setSelectedUser(user);
        setShowModal(true);
    };



    return (
        <>
            <DeleteSuccessfullyModal
                show={showDeleteModal}
                handleClose={() => setShowDeleteModal(false)}
                handleConfirm={handleDelete}
                text="delete User"
            />
            <SuccessfullyModal
                show={showSuccessModal}
                handleClose={() => setShowSuccessModal(false)}
                text="Successfully Deleted"
            />
            <ViewUserProfile
                show={showUserprfileModal}
                data={selectedUser}
                onHide={() => setShowUserProfileModal(false)}
            />
             <CreateOrderchoose
                show={showModal}
                data={selectedUser}
                onHide={() => setShowModal(false)}
            />
            <div className={styles.jobmanagementCotainer}>
                <div className={styles.jobtoppart}>
                    <div className={styles.pagetitle}>
                        <h6>User Management</h6>
                        <div className={styles.searchbarnav}>
                            <IoSearchSharp color='#8A8A8A' size={20} />
                            <input
                                type="search"
                                placeholder="Search"
                                value={search}
                                onChange={handleSearchChange}
                            />
                        </div>
                    </div>
                </div>
                <div className={styles.jobchildcontainer}>
                    <div className={styles.tablecontainer}>
                        <table className={styles.table1}>
                            <thead>
                                <tr>
                                    {columns.map((label, index) => (
                                        <th key={index} className={styles.tableHeader}>{label}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {loading ?
                                    <tr>
                                        <td colSpan="12" style={{ textAlign: "center", padding: "1rem" }}>
                                            <img src={img2} alt="" width={100} height={100} />
                                        </td>
                                    </tr>
                                    :
                                    userdata?.data?.docs?.length === 0 ?
                                        <tr>
                                            <td colSpan="12" style={{ textAlign: "center", padding: "1rem" }}>
                                                No data available.
                                            </td>
                                        </tr>
                                        :
                                        userdata?.data?.docs?.map((register, rowIndex) => (
                                            <tr key={rowIndex} className={styles.tableRow}>
                                                <td className={styles.tableCell}>{rowIndex + 1}</td>
                                                <td className={styles.tableCell}>
                                                    {register.Id}
                                                </td>
                                                <td className={styles.tableCell}>
                                                    <div className={styles.tableprofilecontainer} onClick={() => openModal(register)}>
                                                        <div className={styles.tablecellprofile}>
                                                            <div className={styles.tablecellprofileimg}>
                                                                <img src={register?.image ? register?.image : img} alt="" />
                                                            </div>
                                                        </div>
                                                        {register?.firstName} {register?.lastName}
                                                    </div>
                                                </td>
                                                <td className={styles.tableCell}>{register?.email}</td>
                                                <td className={styles.tableCell}>{register?.phone}</td>
                                                <td className={styles.tableCell}>{register?.wallet}</td>
                                                <td>
                                                    <div className={styles.tableaction}>
                                                        <div className={styles.tablecreatebutton}>
                                                            {/* <Link to={`/user-management/create-order/${register?._id}`}> */}
                                                                <button  onClick={() => openOrderModal(register?._id)}>Create Order</button>
                                                            {/* </Link> */}
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className={styles.tableaction}>
                                                        <div className={styles.tablecreatebutton}>
                                                            <Link to={`/user-management/user-orders/${register?._id}`}>
                                                                <button>View Orders</button>
                                                            </Link>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className={styles.tableaction}>
                                                        <Link to={`/user-management/userprofile/${register?._id}`}>
                                                            <MdOutlineRemoveRedEye size={20} />
                                                        </Link>
                                                        <RiDeleteBin6Line
                                                            size={20}
                                                            onClick={() => openDeleteModal(register._id)}
                                                            style={{ cursor: "pointer", color: "#d9534f" }}
                                                        />
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                            </tbody>
                        </table>
                    </div>
                    <Pagination
                        limit={pagination.limit}
                        totalPages={pagination.totalPages}
                        page={pagination.page}
                        hasPrevPage={pagination.hasPrevPage}
                        hasNextPage={pagination.hasNextPage}
                        onPageChange={(newPage) => setPagination({ ...pagination, page: newPage })}
                    />
                </div>
            </div>
        </>
    )
}

export default HOC(AllUser)